import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LimitsComponent } from './limits.component';
import { SharedModule } from '../../shared/shared.module';
import { LimitsService } from './limits.service';
import { RouterModule } from '@angular/router';
import { MatCardModule, MatIconModule } from '@angular/material';
import { LimitsOtherLimitsComponent } from './other-limits/other-limits.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { LimitsFaqComponent } from './faq/faq.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
	imports: [
		CurrencyMaskModule,
		CommonModule,
		SharedModule,
		MatIconModule,
		MatCardModule,
		RouterModule,
		ReactiveFormsModule,
		FormsModule,
		MatExpansionModule,
		NgxMaskModule.forRoot(),
	],
	declarations: [
		LimitsComponent,
		LimitsOtherLimitsComponent,
		LimitsFaqComponent
	],
	providers: [LimitsService]
})
export class LimitsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/limits.module.ts